import ExcelType from 'exceljs';
import {picdata} from 'Interfaces/picdata';
const Excel: typeof ExcelType = require('exceljs/dist/exceljs.min.js');
const saveAs = require('filesaver.js').saveAs;

export default function saveExcel(data: picdata[]) {
  const workbook = new Excel.Workbook();
  workbook.creator = 'bot';
  workbook.lastModifiedBy = 'bot';
  workbook.created = new Date();
  workbook.modified = new Date();
  const name = prompt('请输入表格名称：');
  if (name) {
    const sheet = workbook.addWorksheet(
      name
    );
    sheet.columns = [
      {header: '#', key: 'id', width: 5},
      {header: '项目名称', key: 'name', width: 10},
      {header: '姓名', key: 'actor', width: 20},
      {header: '日期', key: 'date', width: 10, style: {alignment: {horizontal: 'left'}}},
      {header: '分类', key: 'category', width: 10},
      {header: '标题', key: 'title', width: 40},
      {header: '奖项等第', key: 'level', width: 10},
      {header: '图片', key: 'imgurl', width: 30}
    ];
    const Row = data.map((v, index) => ({
      id: index,
      name: v.项目名称,
      actor: v.姓名,
      date: new Date(v.日期),
      category: v.分类,
      title: v.标题,
      level: v.奖项等第,
      imgurl: {
        text: (new URL(v.路径, `${location.protocol}//${location.host}/`)).toString(),
        hyperlink: (new URL(v.路径, `${location.protocol}//${location.host}/`)).toString()
      }
    }));
    sheet.addRows(Row);
    (workbook.xlsx as any).writeBuffer()
      .then((buffer: Uint8Array) => {
        const blob = new Blob([buffer], {type: 'application/x-msexcel'});
        saveAs(blob, name + '.xlsx');
      });
  } else {
    return;
  }
}



// WEBPACK FOOTER //
// ./src/containers/HomePage/saveExcel.ts